// src/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://collegebackend-e43r.onrender.com/', // Replace with your backend URL
});

// Add a request interceptor to include the token
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('authToken'); // Retrieve from sessionStorage
    // console.log('Retrieved Token from sessionStorage:', token);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn('No token found in sessionStorage.');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export default api;
